import { useEffect, useRef } from 'react';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { getUserInfo } from '@marriott/mi-store-utils';

interface UseGetUserInfoOptions {
  sessionToken: string | undefined;
  requestId: string | undefined;
  currentLocale: string | undefined;
}

/**
 * Calls getUserInfo once per mount as soon as a session token is available.
 * A ref guard prevents duplicate calls even when sessionData, requestId, or
 * currentLocale change after the initial invocation (e.g. after a client-side
 * session refresh), which avoids infinite re-render loops.
 */
export function useGetUserInfo({ sessionToken, requestId, currentLocale }: UseGetUserInfoOptions): void {
  const calledRef = useRef(false);

  useEffect(() => {
    const userId = document?.cookie?.split('UserIdToken=')[1]?.split(';')[0];

    if (!sessionToken || calledRef.current) return;
    calledRef.current = true;

    getUserInfo(false, {
      'x-request-id': requestId,
      'accept-language': currentLocale || '',
      Cookie: `sessionID=${sessionToken};UserIdToken=${userId || ''};`,
    });
  }, [sessionToken, requestId, currentLocale, getUserInfo]);
}
